import { useEffect, useRef } from "react";
import { isEditableTarget } from "../lib/isEditableTarget";

export function useFocusShortcut<T extends HTMLElement>() {
  const ref = useRef<T>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "/" && !isEditableTarget(e)) {
        e.preventDefault();
        ref.current?.focus();
      }
      if (e.key === "Escape" && e.target === ref.current) {
        ref.current?.blur();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return ref;
}
